import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DeprecatedError = ({
  deprecationCta
}) => /*#__PURE__*/_jsx(ErrorMessage, {
  "data-test-id": "deprecated-content-error",
  title: /*#__PURE__*/_jsx(H4, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.deprecated.heading"
    })
  }),
  type: "notFound",
  children: deprecationCta && /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Button, {
      href: deprecationCta,
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyErrors.deprecated.button"
      })
    })
  })
});
export default DeprecatedError;